export default __webpack_public_path__ + "static/media/phones.b0e7e9e2.svg";